import React, { useEffect, useState } from "react";
import ListLayout from "../common/ListLayout";
import FacilityCreateModal from "./CreateFAcilityModal";
import { useGetAllPaginatedApartmentFacilitiesQuery, useDeleteApartmentFacilitiesMutation, useCreateApartmentFacilityMutation } from '../../../store/api/apartment'
import ConfirmDeleteModal from "../common/DeleteModal";
import SuccessModal from "../common/SuccessModal";
const List = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [deleteFacility] = useDeleteApartmentFacilitiesMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [count, setCount] = useState(0);
    const [filters, setFilters] = useState({});
    const [tableData, setTableData] = useState([]);
    const [createFacility] = useCreateApartmentFacilityMutation();
    const { data: ApartmentsData, refetch } = useGetAllPaginatedApartmentFacilitiesQuery({
        page: currentPage,
        page_size: pageSize,
        ...filters,
    });

    const [message, setSuccessMessage] = useState("");
    const [messageType, setMessageType] = useState("success");


    const [isDeleting, setIsDeleting] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [selectFacility, setSelectFacility] = useState(null)


    const [facilityId, setFacilityId] = useState(null)

    // console.log(facilityId, ";facilityId");


    useEffect(() => {
        if (ApartmentsData) {
            setTableData(ApartmentsData.results)
            setCount(ApartmentsData.count)
        }

    }, [ApartmentsData])



    const tableHeaders = [
        { label: "Name", key: "name" },
        { label: "Service Type", key: "type" },
    ];


    const actionButtons = [
        {
            icon: "MdOutlineRemoveRedEye",
            onClick: (row) => console.log(`View ${row.id}`),
        },
        {
            icon: "MdOutlineModeEdit",
            onClick: (row) => {
                setFacilityId(row.id)
                setIsModalOpen(true)
            },
        },
        {
            icon: "RiDeleteBinLine",
            onClick: (row) => {
                setSelectFacility(row)
                setDeleteModalOpen(true)

            }
        }
    ];
    const handleConfirmDelete = async () => {
        if (!selectFacility) return;
        setIsDeleting(true);
        try {
            await deleteFacility(selectFacility.id).unwrap();
            setDeleteModalOpen(false);
            setSelectFacility(null);
            refetch();
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete Facility.");
        } finally {
            setIsDeleting(false);
        }
    };
    const handleNotification = (message, type = "success") => {
        setSuccessMessage(message);
        setMessageType(type);
    };


    return (
        <>
            <ListLayout
                title=""

                tableHeaders={tableHeaders}
                tableData={tableData}
                actionButtons={actionButtons}
                currentPage={currentPage}
                onAddNewButton={() => setIsModalOpen(true)}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalCount={count}
            />
            <FacilityCreateModal
                isOpen={isModalOpen}
                onNotification={handleNotification}
                onClose={() => {
                    setIsModalOpen(false);
                    setFacilityId(null); // ✅ clear facilityId when closing
                }}
                facilityId={facilityId}
                createFacility={createFacility}
                onSuccess={refetch}
            />
            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                itemName={selectFacility?.name}

                isDeleting={isDeleting}
            />
            <SuccessModal
                message={message}
                type={messageType}
                onClose={() => setSuccessMessage("")}
            />

        </>
    );
};

export default List;
